import ClauseTypeType from '../../store/schema/ClauseTypeType';

export default function getDefaultInboxRuleClauseValue(clauseType: ClauseTypeType): any {
    switch (clauseType) {
        case 'markImportance':
        case 'withImportance':
            return 'NullImportance';
        case 'sensitivity':
            return 'NullSensitivity';
        case 'type':
            return 'NullInboxRuleMessageType';
        case 'flag':
            return 'NullInboxRuleMessageFlag';
        case 'moveTo':
        case 'copyTo':
        case 'junk':
        case 'forwardTo':
        case 'forwardAsAttachmentTo':
        case 'redirectTo':
        case 'from':
        case 'to':
        case 'subjectIncludes':
        case 'subjectOrBodyIncludes':
        case 'inTheBody':
        case 'inTheSenderAddress':
        case 'inTheRecipientAddress':
        case 'inTheMessageHeader':
        case 'atLeast':
        case 'atMost':
        case 'before':
        case 'after':
        case 'category':
        case 'any':
            return null;
        case 'read':
        case 'pin':
        case 'delete':
        case 'attachment':
        case 'onTheToOrCcLine':
        case 'theOnlyRecipientListed':
        case 'onTheToLine':
        case 'onTheCcLine':
        case 'notOnTheToLine':
            return false;
        default:
            throw new Error(
                'Cannot get an initial inbox rule clause value for a clause type that does not exist'
            );
    }
}
